export class NewsteoSubscription {
  public osmosProjectId: number;
  public newsteoProjectId: number;
}
